"use client";

import { c as _c } from "react/compiler-runtime";
import { IconCheckOutline18, IconCopyOutline18 } from "nucleo-ui-outline-18";
import { Button } from "@/components/ui/button";
import { useCallback, useState } from "react";

/** API response type for x402 action details */
export interface X402ActionResponse {
  code: number;
  data?: {
    exampleInput?: unknown;
    exampleOutput?: unknown;
  };
}

/** Generate default input values from a JSON Schema for Quick Test */
export function generateDefaultInputs(schema: Record<string, unknown> | undefined): Record<string, unknown> {
  const properties = (schema as {
    properties?: Record<string, Record<string, unknown>>;
  })?.properties;
  if (!properties) return {};
  const inputs: Record<string, unknown> = {};
  for (const [key, prop] of Object.entries(properties)) {
    if (key.startsWith("_")) continue;
    if (prop.default !== undefined) inputs[key] = prop.default;else if (prop.type === "string") inputs[key] = "";else if (prop.type === "number") inputs[key] = 0;else if (prop.type === "boolean") inputs[key] = false;else if (prop.type === "array") inputs[key] = [];else if (prop.type === "object") inputs[key] = {};else inputs[key] = "";
  }
  return inputs;
}

/**
 * Copy button component for copying text to clipboard
 */
export function CopyButton(t0) {
  const $ = _c(11);
  const {
    value,
    className,
    label
  } = t0;
  const [copied, setCopied] = useState(false);
  let t1;
  if ($[0] !== value) {
    t1 = async e => {
      e.stopPropagation();
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    };
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCopy = t1;
  const t2 = `hover:bg-ds-neutral-200 dark:hover:bg-ds-neutral-700 flex items-center gap-1.5 rounded-md p-2 text-sm transition-colors ${className || ""}`;
  let t3;
  if ($[2] !== copied) {
    t3 = copied ? <IconCheckOutline18 className="h-4 w-4 text-green-500" /> : <IconCopyOutline18 className="text-ds-text-muted h-4 w-4" />;
    $[2] = copied;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== label) {
    t4 = label && <span className="text-ds-text-muted">{label}</span>;
    $[4] = label;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== handleCopy || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <button onClick={handleCopy} className={t2} title="Copy to clipboard">{t3}{t4}</button>;
    $[6] = handleCopy;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}

/**
 * Copy JSON button using RetroButton styling
 */
export function CopyJsonButton(t0) {
  const $ = _c(10);
  const {
    value
  } = t0;
  const [copied, setCopied] = useState(false);
  let t1;
  if ($[0] !== value) {
    t1 = async () => {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    };
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCopy = t1;
  let t2;
  if ($[2] !== copied) {
    t2 = copied ? <IconCheckOutline18 className="h-3 w-3" /> : <IconCopyOutline18 className="h-3 w-3" />;
    $[2] = copied;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = copied ? "Copied!" : "Copy JSON";
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <span className="flex items-center gap-2 px-2">{t2}{t3}</span>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== handleCopy || $[8] !== t4) {
    t5 = <Button variant="white" size="sm" className="text-xs" onClick={handleCopy}>{t4}</Button>;
    $[7] = handleCopy;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}